import { SxProps, Theme } from '@mui/material';
import { ZIndex } from '@/utils/zIndex';

export const modalRootSX: SxProps<Theme> = { zIndex: ZIndex.HIGHEST };

export const modalSX: SxProps<Theme> = { padding: 0 };

export const dialogContainerSX: SxProps<Theme> = {
	backgroundColor: '#FFFFFF',
	position: 'absolute',
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
	height: 'auto',
	top: { xs: 'auto', sm: '50%' },
	bottom: { xs: 0, sm: 'auto' },
	left: { xs: 0, sm: '50%' },
	right: { xs: 0, sm: 'auto' },
	transform: { xs: 'none', sm: 'translate(-50%, -50%)' },
	width: { xs: '100%', sm: '660px' },
	maxWidth: { xs: '100%', sm: 'calc(100vw - 32px)' },
	maxHeight: { xs: '90dvh', sm: '70vh' },
	borderRadius: { xs: '12px 12px 0 0', sm: '6px' },
	padding: { xs: '34px 20px 24px', sm: '40px 36px 32px' },
	boxSizing: 'border-box',
	outline: 'none',
};

export const closeButtonSX: SxProps<Theme> = {
	position: 'absolute',
	right: { xs: '7px', sm: '10px' },
	top: { xs: '7px', sm: '10px' },
	fontSize: '24px',
	color: '#1F1F1F',
	padding: '4px',
	'&:hover': {
		backgroundColor: 'transparent',
		color: '#1F1F1F',
	},
};

export const contentSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
	minHeight: 0,
	overflow: 'hidden',
	fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
};

export const titleSX: SxProps<Theme> = {
	color: '#2C2C2C',
	fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
	fontSize: { xs: '18px', sm: '22px' },
	fontWeight: 800,
	lineHeight: { xs: '22px', sm: '26px' },
	marginBottom: '12px',
	textTransform: 'uppercase',
	textAlign: { xs: 'center', sm: 'left' },
};

export const descriptionSX: SxProps<Theme> = {
	color: '#5A5A5A',
	fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
	fontSize: '13px',
	fontWeight: 400,
	lineHeight: '18px',
	margin: { xs: '4px 0 14px', sm: '5px 0 16px' },
	textAlign: { xs: 'center', sm: 'left' },
};

export const couponBannerSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: '#F7F7F7',
	borderRadius: '4px',
	overflow: 'hidden',
	boxSizing: 'border-box',
};

export const couponLoginRowSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: { xs: 'center', md: 'flex-start' },
	gap: { xs: '12px', sm: '6px' },
	backgroundColor: '#FFF5D8',
	color: '#9A5A11',
	padding: { xs: '10px 36px', sm: '6px 20px' },
	minHeight: { xs: '55px', sm: '32px' },
	boxSizing: 'border-box',
	borderRadius: '5px 5px 0px 0px',
};

export const couponLoginIconSX: SxProps<Theme> = {
	color: '#9A5A11',
	fontSize: { xs: '28px', sm: '20px' },
	flex: '0 0 auto',
};

export const couponLoginTextSX: SxProps<Theme> = {
	color: '#9A560A',
	fontSize: { xs: '15px', sm: '16px' },
	fontWeight: 800,
	lineHeight: { xs: '19px', sm: '20px' },
	textAlign: { xs: 'center', sm: 'left' },
};

export const couponBodySX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: '#F7F7F7',
	padding: { xs: '8px 18px 12px', sm: '8px 20px 10px' },
};

export const couponTopRowSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: { xs: 'column', sm: 'row' },
	alignItems: { xs: 'center', sm: 'flex-start' },
	justifyContent: { xs: 'center', sm: 'space-between' },
	gap: { xs: '8px', sm: '16px' },
};

export const couponLabelGroupSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '2px',
	minWidth: 0,
	alignItems: { xs: 'center', sm: 'flex-start' },
	textAlign: { xs: 'center', sm: 'left' },
};

export const couponEyebrowSX: SxProps<Theme> = {
	color: '#3D3D3D',
	fontSize: { xs: '14px', sm: '14px' },
	fontWeight: 400,
	lineHeight: { xs: '18px', sm: '18px' },
};

export const couponLabelSX: SxProps<Theme> = {
	color: '#2F2F2F',
	fontSize: { xs: '16px', sm: '17px' },
	fontWeight: 800,
	lineHeight: { xs: '20px', sm: '22px' },
	textTransform: 'uppercase',
};

export const couponCodeButtonSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '8px',
	border: '1px dashed #2784E9',
	borderRadius: '999px',
	padding: { xs: '13px 24px', sm: '17px 18px' },
	flex: '0 0 auto',
	width: { xs: '100%', sm: 'auto' },
	maxWidth: { xs: '260px', sm: 'none' },
	minWidth: { xs: '260px', sm: '210px' },
	minHeight: { xs: '50px', sm: '58px' },
};

export const couponCodeSX: SxProps<Theme> = {
	color: '#2784E9',
	fontSize: { xs: '18px', sm: '18px' },
	fontWeight: 800,
	letterSpacing: '1.4px',
	lineHeight: '22px',
};

export const couponCopyIconSX: SxProps<Theme> = {
	color: '#2784E9',
	fontSize: '18px',
};

export const couponExpirySX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: { xs: 'center', sm: 'flex-start' },
	gap: '3px',
	color: '#D32F2F',
	fontSize: { xs: '16px', sm: '15px' },
	fontWeight: 700,
	lineHeight: { xs: '20px', sm: '16px' },
	marginTop: { xs: '10px', sm: '-14px' },
};

export const couponExpiryIconSX: SxProps<Theme> = {
	fontSize: { xs: '14px', sm: '13px' },
};

export const couponInfoSX: SxProps<Theme> = {
	display: 'block',
	color: '#2C2C2C',
	fontSize: { xs: '13px', sm: '12px' },
	fontWeight: 400,
	lineHeight: { xs: '17px', sm: '16px' },
	marginTop: { xs: '4px', sm: '2px' },
	textAlign: { xs: 'center', sm: 'left' },
};

export const couponInfoIconSX: SxProps<Theme> = {
	fontSize: { xs: '14px', sm: '13px' },
	marginTop: '1px',
	marginRight: '2px',
	verticalAlign: 'text-top',
};

export const productListSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
	minHeight: 0,
	overflowY: 'auto',
	margin: { xs: '4px 0 0', sm: '6px 0 0' },
};

export const productRowSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	gap: { xs: '10px', sm: '14px' },
	padding: '14px 0',
	borderBottom: '1px solid #EFEFEF',
};

export const productImageFrameSX: SxProps<Theme> = {
	width: { xs: '64px', sm: '72px' },
	height: { xs: '64px', sm: '72px' },
	backgroundColor: '#F2F2F2',
	flex: '0 0 auto',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	overflow: 'hidden',
	borderRadius: '4px',
};

export const productImageSX: SxProps<Theme> = {
	width: '100%',
	height: '100%',
	objectFit: 'contain',
	display: 'block',
};

export const productInfoSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '6px',
	flex: 1,
	minWidth: 0,
};

export const productNameSX: SxProps<Theme> = {
	color: '#2C2C2C',
	fontSize: '14px',
	fontWeight: 600,
	lineHeight: '18px',
	margin: 0,
};

export const productPriceSX: SxProps<Theme> = {
	color: '#1C1C1C',
	fontSize: '14px',
	fontWeight: 700,
	lineHeight: '18px',
};

export const actionsSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: { xs: 'column-reverse', sm: 'row' },
	gap: '12px',
	width: '100%',
	marginTop: { xs: '20px', sm: '24px' },
};

export const actionItemSX: SxProps<Theme> = {
	flex: 1,
	display: 'flex',
};

export const actionButtonSX: SxProps<Theme> = {
	minHeight: '44px',
	fontSize: '14px',
	fontWeight: 800,
	lineHeight: '18px',
	textTransform: 'none',
	borderRadius: '22px',
};

export const productPriceSizeRowSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: { xs: 'row', sm: 'column' },
	alignItems: { xs: 'center', sm: 'flex-start' },
	justifyContent: { xs: 'space-between', sm: 'flex-start' },
	gap: '6px',
};
